export default function PhotoGallery() {
  const photos = [
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/602462fd18650d1fccd90e86a3e6330d.png',
      caption: 'Tunnel Run - Youth Night at the Ralph'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/b12a45df6f6542fbd0d2dc259965302e.png',
      caption: 'Cal Pride'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/2368a28efaab0ed3ff36b8e636080c2f.png',
      caption: 'Game Day!'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/136d46ad37f46d670cfa0af60708aa7e.png',
      caption: 'Bonds that last a lifetime'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/3f7b55afb5994c7b9f8e1ca3dea6d674.png',
      caption: 'Girls Flag!'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/8b5ebca919876169781c0d914048d21b.png',
      caption: 'Offseason Training'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/bd6c81231f76c86857672132dd1ca917.png',
      caption: 'Bills Pride'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/4c520b5ecfc6cce37944323a873a36ef.png',
      caption: 'Youth Night at the Ralph'
    },
    {
      url: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/aefc281b060182e520682167a9563ef3.png',
      caption: 'Game Time!'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            The Kids <span className="text-purple-700">You're Supporting</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto font-medium">
            Every sponsorship dollar makes a real difference in these young lives
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {photos.filter(photo => photo.url).map((photo, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-2xl shadow-xl group cursor-pointer"
            >
              <div className="w-full h-80">
                <img
                  src={photo.url}
                  alt={photo.caption}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <p className="text-white text-xl font-bold p-6">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-purple-900 rounded-3xl p-12 text-center">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-6">
            These Moments Are Made Possible By Sponsors Like You
          </h3>
          <p className="text-xl text-purple-100 max-w-3xl mx-auto leading-relaxed">
            Your investment creates memories, builds character, and strengthens our community through the power of youth athletics.
          </p>
        </div>
      </div>
    </section>
  );
}